"use strict";

/**
 * @classdesc
 * Featureobjekt als Ergebnis einer Query-Funktion des FeatureServices.
 *
 * @class
 * @abstract
 * @extends gc.gis.GCObservable
 * @memberof gc.gis.service
 * @author Christian Schmidt <c.schmidt@brain-scc.de>
 */
gc.gis.service.feature.AbstractQueryFeature = function()
{
	gc.gis.GCObservable.call(this);

	/**
	 * ID des Features.
	 * @type {string|int}
	 * @private
	 */
	this._id = undefined;

	/**
	 * Name des Layers, der das Feature enthält (insbesondere bei Gruppenlayer (Ausnahme FachDB-Layer) von Bedeutung)
	 * @type {string}
	 */
	this._featureLayer = undefined;

	/**
	 * Liste der Attribute.
	 * @type {Object<string,*>}
	 * @private
	 */
	this._attributes = {};

	/**
	 * Name des Titel-Attributs.
	 * @type {string}
	 * @private
	 */
	this._titleName = undefined;

	/**
	 * HTML-Detail-Ergebnis.
	 * @type {string}
	 */
	this._htmlDetailResult = undefined;

	/**
	 * Aktionen des Features.
	 * @type {Object[]}
	 * @private
	 */
	this._actions = {};
};
gc.gis.service.feature.AbstractQueryFeature.prototype = Object.create(gc.gis.GCObservable.prototype);

/**
 * Liefert die ID des Features.
 *
 * @return {string|int}
 */
gc.gis.service.feature.AbstractQueryFeature.prototype.getID = function ()
{
	return this._id;
};

/**
 * Setzt die ID des Features.
 *
 * @param {string|int} id
 * @return {gc.gis.service.feature.AbstractQueryFeature}
 */
gc.gis.service.feature.AbstractQueryFeature.prototype.setID = function (id)
{
	this._id = id;

	return this;
};

/**
 * Liefert den Layer, welcher das Objekt enthält (wichtig bei Gruppen-Layern).
 *
 * @return {string}
 */
gc.gis.service.feature.AbstractQueryFeature.prototype.getFeatureLayer = function ()
{
	return this._featureLayer;
};

/**
 * Setzt den Layer, welcher das Objekt enthält (wichtig bei Gruppen-Layern).
 *
 * @param {string} layer_name
 * @return {gc.gis.service.feature.AbstractQueryFeature}
 */
gc.gis.service.feature.AbstractQueryFeature.prototype.setFeatureLayer = function (layer_name)
{
	this._featureLayer = layer_name;

	return this;
};

/**
 * Liefert ein Attributwert.
 *
 * @return {*}
 */
gc.gis.service.feature.AbstractQueryFeature.prototype.getAttribute = function (name)
{
	var attr;
	if (name)
	{
		name = name.toLowerCase();
		if (this._attributes.hasOwnProperty(name))
		{
			attr = this._attributes[name];
		}
	}

	return attr;
};

/**
 * Liefert de Attribute.
 *
 * @return {Object.<string, *>}
 */
gc.gis.service.feature.AbstractQueryFeature.prototype.getAttributes = function ()
{
	return this._attributes;
};

/**
 * Setzt einen Attributwert.
 *
 * @param {string} name
 * @param {*} value
 * @return {gc.gis.service.feature.AbstractQueryFeature}
 */
gc.gis.service.feature.AbstractQueryFeature.prototype.setAttribute = function (name, value)
{
	this._attributes[name.toLowerCase()] = value;
	return this;
};

/**
 * Setzt einen Attributwert.
 *
 * @param {Object.<string, *>} attributes
 * @return {gc.gis.service.feature.AbstractQueryFeature}
 */
gc.gis.service.feature.AbstractQueryFeature.prototype.setAttributes = function (attributes)
{
	var name;
	for (name in attributes)
	{
		this.setAttribute(name, attributes[name]);
	}
	return this;
};

/**
 * Setzt einen Attributwert zurück.
 *
 * @param {string} name
 * @return {gc.gis.service.feature.AbstractQueryFeature}
 */
gc.gis.service.feature.AbstractQueryFeature.prototype.unsetAttribute = function (name)
{
	name = name.toLowerCase();
	if (name in this._attributes)
	{
		delete this._attributes[name];
	}
	return this;
};

/**
 * Liefert das den Attributwert, welcher als Titel verwendet werden soll.
 *
 * @return {*}
 */
gc.gis.service.feature.AbstractQueryFeature.prototype.getTitle = function ()
{
	return this.getAttribute(this._titleName);
};

/**
 * Setzt den Namen des Titel-Attributs.
 *
 * @param {string} name
 * @return {gc.gis.service.feature.AbstractQueryFeature}
 */
gc.gis.service.feature.AbstractQueryFeature.prototype.setTitleName = function (name)
{
	this._titleName = name;
	return this;
};

/**
 * Liefert den Namen des Titel-Attributs.
 *
 * @return {string}
 */
gc.gis.service.feature.AbstractQueryFeature.prototype.getTitleName = function ()
{
	return this._titleName;
};

/**
 * Liefert eine Liste von Aktionen.
 *
 * @return {Object[]}
 */
gc.gis.service.feature.AbstractQueryFeature.prototype.getActions = function ()
{
	return this._actions;
};

/**
 * Setzt eine Liste von Aktionen.
 *
 * @param {Object[]} actions
 * @return {gc.gis.service.feature.AbstractQueryFeature}
 */
gc.gis.service.feature.AbstractQueryFeature.prototype.setActions = function (actions)
{
	this._actions = actions;
	return this;
};


/**
 * Liefert das HTML-Detail-Ergebnis.
 *
 * @return {string}
 */
gc.gis.service.feature.AbstractQueryFeature.prototype.getHTMLDetailResult = function ()
{
	return this._htmlDetailResult;
};

/**
 * Setzt das HTML-Detail-Ergebnis.
 *
 * @param {string} html
 * @return {gc.gis.service.feature.AbstractQueryFeature}
 */
gc.gis.service.feature.AbstractQueryFeature.prototype.setHTMLDetailResult = function (html)
{
	this._htmlDetailResult = html;
	return this;
};

/**
 * Liefert die Geometrie zum Feature. Je nach Bedarf werden bei Objekten mit mehreren Geometrien (z.B. FachDB-Features)
 * die Liste von Geometrien als Geometrie-Collection bereitgestellt.
 *
 * @return {gc.gis.geom.GCGeometry}
 */
gc.gis.service.feature.AbstractQueryFeature.prototype.getGeometry = gc.gis.abstractMethod;